import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import ROUTES from '../../../../config/routes';
import PrintFractionalPackagingLabel from '../../../../components/printLabel/fractionalPackaging';

class LabelFractionalPackaging extends React.PureComponent {
  constructor() {
    super();
    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>
        ),
      },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE1371' /* Etiquetas */) },
      { value: I18n.t('BEE4207' /* Etiqueta de Embalagem Fracionada */), active: true },
    ];
  }

  render() {
    return (
      <div>
        <PrintFractionalPackagingLabel
          breadcrumb={this.breadcrumb}
          noButton
          title={I18n.t('BEE4207' /* Etiqueta de Embalagem Fracionada */)}
          wikiHelp={ROUTES.FRACTIONAL_PACKAGING_LABEL_HELP}
          showAllColumnsDatatable
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({
});
const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(LabelFractionalPackaging);
